import DownloadSVG from "@design-system/ui-icons/vanilla/Download"
import { createIcon } from "../createIcon"

export const DownloadIcon = createIcon(DownloadSVG)
